import "./Csedept_Project_Card.css";
import { FaLinkedin } from "react-icons/fa";
import { useState } from "react";

const Csedept_Project_Card = ({
  projectTitle,
  projectDesc,
  staffName,
  staffDesi,
  students, // { secondYear: [], thirdYear: [], fourthYear: [] }
}) => {
  const [visibleBatch, setVisibleBatch] = useState("");

  const toggleBatch = (batchName) => {
    setVisibleBatch((prevBatch) => (prevBatch === batchName ? "" : batchName));
  };

  return (
    <div className="project-card">
      <div className="project-title-section">
        <h2 className="project-heading">{projectTitle}</h2>
        <div className="underline" />
      </div>

      <div className="project-body">
        <p className="project-description">{projectDesc}</p>

        <div className="project-staff">
          <h4>Staff Coordinator</h4>
          <h6>{staffName}</h6>
          <h6>{staffDesi}</h6>
        </div>

        <div className="project-students">
          {/* <h4>Student Contributors</h4> */}
          <div className="students-row">

            {students?.fourthYear?.length > 0 && (
              <div className="year-group two-columns">
                <button
                  className="batch-toggle-button"
                  onClick={() => toggleBatch("2021-2025")}
                >
                  2021 - 2025 Batch
                </button>
                {visibleBatch === "2021-2025" && (
                  <ul className="students-list-two-columns-list">
                    {students.fourthYear.map((student, index) => (
                      <li key={`4th-${index}`}>
                        <a
                          href={student.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="student-link"
                        >
                          {student.name}
                          <span className="linkedin-icon">
                            <FaLinkedin />
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {students?.thirdYear?.length > 0 && (
              <div className="year-group two-columns">
                <button
                  className="batch-toggle-button"
                  onClick={() => toggleBatch("2022-2026")}
                >
                  2022 - 2026 Batch
                </button>
                {visibleBatch === "2022-2026" && (
                  <ul className="students-list-two-columns-list">
                    {students.thirdYear.map((student, index) => (
                      <li key={`3rd-${index}`}>
                        <a
                          href={student.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="student-link"
                        >
                          {student.name}
                          <span className="linkedin-icon">
                            <FaLinkedin />
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {students?.secondYear?.length > 0 && (
              <div className="year-group two-columns">
                <button
                  className="batch-toggle-button"
                  onClick={() => toggleBatch("2023-2027")}
                >
                  2023 - 2027 Batch
                </button>
                {visibleBatch === "2023-2027" && (
                  <ul className="students-list-two-columns-list">
                    {students.secondYear.map((student, index) => (
                      <li key={`2nd-${index}`}>
                        <a
                          href={student.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="student-link"
                        >
                          {student.name}
                          <span className="linkedin-icon">
                            <FaLinkedin />
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Csedept_Project_Card;
